import { useState, useEffect } from "react";

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const media = window.matchMedia(query);
    const handleChange = () => setMatches(media.matches);

    // Set the initial value
    setMatches(media.matches);

    // Add listener
    media.addEventListener("change", handleChange);

    // Cleanup
    return () => media.removeEventListener("change", handleChange);
  }, [query]);

  return matches;
}
